import { Select } from "@mui/material";
import { styled } from "@mui/material/styles";

// Same component as dm-commerce-b2b-web (CustomPaginationSelect): the compact
// select used for page size and period dropdowns. Pair with CustomMenuItem.
export const CustomPaginationSelect = styled(Select)(() => ({
  width: "80px",
  height: "30px !important",
  fontSize: "14px",
  borderRadius: "4px",
  fontFamily: "inherit",
  color: "var(--color-text)",
  backgroundColor: "var(--color-bg-white)",
  "&.Mui-focused": {
    outline: "none",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--color-input-border)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--color-input-border)",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "var(--color-input-border)",
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
  },
  "& .MuiInputBase-input:focus": {
    fontWeight: 500,
  },
}));
